import { createAction } from '@ngrx/store';

export const openTermsAndConditionsDialog = createAction('Open Terms and Conditions Dialog');
export const openTermsAndConditionsDialogSuccess = createAction(
  'Open Terms and Conditions Dialog Success',
);
